import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-patterns',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map